import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Grommet, ResponsiveContext } from 'grommet';
import { GlobalStyle, Box } from './components/element';
import { Header } from './components/page/header';
import { Footer } from './components/page/footer';
import { MainPage } from './containers/mainPage';
import { LandingRoute } from './RoutesConfig';
import HPE from './themes/HPE';
import { URL_BASENAME } from './constants';
import { withTracker } from './utils/withTracker';

class App extends Component {
  render() {
    return (
      <React.Fragment>
        <Grommet theme={HPE} full={false}>
          <ResponsiveContext.Consumer>
            {size => (
              <Box direction="column" className="fullScreen">
                <Header />
                <Router basename={URL_BASENAME}>
                  <Switch>
                    <Route
                      path={LandingRoute.path}
                      exact={LandingRoute.exact}
                      component={withTracker(LandingRoute.component)}
                    />
                    <Route render={props => <MainPage responsive={size} {...props} />} />
                  </Switch>
                </Router>
                <Footer />
              </Box>
            )}
          </ResponsiveContext.Consumer>
        </Grommet>
        <GlobalStyle />
      </React.Fragment>
    );
  }
}
export default App;
